import './style.scss';

import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import NiceModal from '@ebay/nice-modal-react';
import { MdKeyboardArrowRight } from 'react-icons/md';

import { Text } from '../../atoms';
import ModalMeetingDetails from '../../modals/ModalMeetingDetails';
import { buildAllMeetingsPath } from '../../Pages/AllMeetings';
import CardMeeting from './components/CardMeeting';
import { MeetingItem, SECTION_LIMIT, getUpcomingMeetings, splitByHighlight } from './utils';

type Props = {
    data: any;
    _parentData: any;
};

const Meeting = ({ data, _parentData }: Props) => {
    const history = useHistory();
    const nodeTitle = _parentData?.node?.title || '';
    const nodeCode: string = _parentData?.node?.nodeCode || '';
    const idTeam: number | undefined =
        _parentData?.node?.nodeEnrollment?.team?.idTeam || data?.meetings?.[0]?.idTeam;

    const [now, setNow] = useState(() => moment());

    useEffect(() => {
        const timer = setInterval(() => setNow(moment()), 60000);

        return () => clearInterval(timer);
    }, []);

    const upcomingMeetings = useMemo<MeetingItem[]>(
        () => getUpcomingMeetings(data?.meetings || [], now).slice(0, SECTION_LIMIT),
        [data?.meetings, now]
    );

    const { highlighted, standard } = useMemo(() => splitByHighlight(upcomingMeetings), [upcomingMeetings]);

    const hasUpcoming = Boolean(upcomingMeetings.length);
    const canSeeAllMeetings = Boolean(idTeam && nodeCode);

    const openDetails = (meeting: MeetingItem) => {
        NiceModal.show(ModalMeetingDetails, {
            obj: { meeting, fallbackTitle: nodeTitle },
        });
    };

    const openAllMeetings = () => {
        if (!idTeam) {
            return;
        }

        history.push(buildAllMeetingsPath(idTeam, nodeCode));
    };


    return (
        <div className={`pctOrganism pctGrid ${data.parameters.description ? 'pctGridInText' : ''} ${data.className}`}>
            <div className="meetingHeader">
                {nodeTitle && <Text component="h3" text={`Eventos de ${nodeTitle}`} className="titleSection" />}

                {canSeeAllMeetings && (
                    <button type="button" className="seeAllEvents" onClick={openAllMeetings}>
                        Ver todos os eventos
                        <MdKeyboardArrowRight />
                    </button>
                )}
            </div>

            {data.description && <Text component="p" text={data.parameters.description} className="textSection" />}

            {hasUpcoming ? (
                <div className="listMeeting">
                    {highlighted.map((meeting) => (
                        <CardMeeting
                            key={meeting.idMeeting}
                            meeting={meeting}
                            highlight
                            fallbackTitle={nodeTitle}
                            onSelect={openDetails}
                        />
                    ))}

                    {standard.map((meeting) => (
                        <CardMeeting
                            key={meeting.idMeeting}
                            meeting={meeting}
                            fallbackTitle={nodeTitle}
                            onSelect={openDetails}
                        />
                    ))}

                    {canSeeAllMeetings && (
                        <button type="button" className="seeAllEvents" onClick={openAllMeetings}>
                            Ver todos os eventos
                        </button>
                    )}
                </div>
            ) : (
                <Text component="p" text="Todos os eventos foram realizados." className="emptyMeetings" />
            )}
        </div>
    );
};

export default Meeting;
